import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import PaiyaGiftPage from "components/pages/paiyaGifts/PaiyaGiftsPage";
import { IPaiyaUploadNormalizer } from "interfaces/Index";


export const mapStateToProps = (state: any) => {
    return {
        paiyaGifts: state.paiyaGift.paiyaGifts,
        isLoading: state.paiyaGift.isLoading,
        isError: state.paiyaGift.isError,
        error: state.paiyaGift.error,
        isPaiyaGiftCreated: state.paiyaGift.isPaiyaGiftCreated
    }
}

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        fetchPaiyaGifts: (
            searchKey: string,
            giftType: string
        ) => dispatch(
            actions.fetchPaiyaGifts(
                searchKey,
                giftType
            )
        ),
        uploadImageAndCreatePaiyaGiftAction: (
            formData: FormData,
            payload: IPaiyaUploadNormalizer,
        ) => dispatch(
            actions.uploadImageAndCreatePaiyaGiftAction(
                formData,
                payload
            )
        ),
        clearPaiyaGiftDetails: () => dispatch(actions.clearPaiyaGiftDetails())
    }
}

const PaiyaGiftsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PaiyaGiftPage);

export default PaiyaGiftsContainer;
